/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popTerms.vue?vue&type=template&id=0506055d"
import script from "./popTerms.vue?vue&type=script&lang=js"
export * from "./popTerms.vue?vue&type=script&lang=js"
import style0 from "./popTerms.vue?vue&type=style&index=0&id=0506055d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports